import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import elementEnLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';// element-ui lang

const enModulesFiles = require.context('./en', true, /\.js$/);
const enModuleObj = {}; const zhModuleObj = {};
const enLocaleModules = enModulesFiles.keys().reduce((modules, modulePath) => {
  const value = enModulesFiles(modulePath);
  for (var pro in value.default) {
    enModuleObj[pro] = value.default[pro];
  }
  return enModuleObj;
}, {});

const zhModulesFiles = require.context('./zh', true, /\.js$/);
const zhLocaleModules = zhModulesFiles.keys().reduce((modules, modulePath) => {
  const value = zhModulesFiles(modulePath);
  for (var pro in value.default) {
    zhModuleObj[pro] = value.default[pro];
  }
  return zhModuleObj;
}, {});

Vue.use(VueI18n);

const messages = {
  en: {
    ...elementEnLocale,
    ...enLocaleModules
  },
  zh: {
    ...elementZhLocale,
    ...zhLocaleModules
  },
};
export function getLanguage() {
  const chooseLanguage = Cookies.get('language');
  if (chooseLanguage) return chooseLanguage;

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return 'en';
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
});

export default i18n;
